/**
 * Top-level complete vs incomplete KPIs.
 */
export default function CompletenessStatsStrip({ stats, loading }) {
  if (loading && !stats) {
    return (
      <p className="text-sm theme-text-secondary mb-4">Loading profile stats…</p>
    );
  }
  if (!stats) return null;

  const cards = [
    { label: 'Active students', value: stats.totalActive },
    { label: 'Profiles complete', value: stats.completeCount },
    { label: 'Incomplete', value: stats.incompleteCount },
    { label: '% complete', value: `${stats.completePercent}%` },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
      {cards.map((card) => (
        <div
          key={card.label}
          className="rounded-lg p-4 border"
          style={{
            borderColor: 'var(--color-border)',
            backgroundColor: 'var(--color-surface)',
          }}
        >
          <p className="text-xs theme-text-secondary mb-1">{card.label}</p>
          <p className="text-2xl font-semibold theme-text">{card.value}</p>
        </div>
      ))}
    </div>
  );
}
